/* eslint-disable global-require,import/no-unresolved, react/forbid-prop-types, react/no-array-index-key */
import React from 'react'
import {
 Dimensions, Text, TouchableWithoutFeedback, View,
} from 'react-native'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Image from 'react-native-scalable-image'
import styles from '../../../styles'
import textStyles from '../../../styles/text'
import panelStyles from '../../../styles/panel'
import * as ResourceManager from '../../methods/ResourceManager'
import { gotoTab } from '../../../actions/helpers'

function gotoIndicatorLights() {
  gotoTab('IndicatorLights', 'IndicatorLights')
}

function CommunicatorWorking(props) {
  const { t } = props
  return (
    <View>
      <View style={textStyles.faqH1Container}>
        <Text style={[textStyles.h1, styles.shark_grey]} testID="how-know-working-header">{t('howKnowCommunicatorWorking')}</Text>
      </View>
      <View>
        <Image
          style={[panelStyles.lightImage, styles.textMargin]}
          width={Dimensions.get('window').width - 100}
          source={{ uri: ResourceManager.loadImage('communicator_faq') }}
        />
        <Text style={textStyles.bodyContentText}>
          {t('communicatorWorkingParagraph1')}
          {' '}
          <Text style={textStyles.bodyContentTextBold}>{t('communicatorWorkingPressAndHold')}</Text>
        </Text>
        <Image
          style={[panelStyles.lightImage, styles.textMargin, styles.marginBottom16]}
          width={Dimensions.get('window').width - 200}
          source={{ uri: ResourceManager.loadImage('comm_working') }}
        />
        <Text style={textStyles.bodyContentText}>{t('communicatorWorkingParagraph2')}</Text>
        <View style={styles.hyperlinkView}>
          <TouchableWithoutFeedback
            accessibilityLabel="IndicatorLights"
            onPress={gotoIndicatorLights}
            testID="indicator-lights-btn"
          >
            <View>
              <Text testID="indicator-lights-btn-text" style={textStyles.bodyContentText}>
                {t('communicatorWorkingParagraph3')}
                <Text style={styles.hyperlink}>
                  {' '}
                  {t('communicatorWorkingIndicatorLightsLink')}
                  {' '}
                </Text>
                {t('communicatorWorkingParagraph3Finish')}
              </Text>
            </View>
          </TouchableWithoutFeedback>
        </View>
      </View>
    </View>
  )
}

CommunicatorWorking.propTypes = {
  t: PropTypes.func.isRequired,
}

const actionCreators = {
}
export const CommunicatorWorkingComponent = CommunicatorWorking

export default withTranslation('faq')(connect(null, actionCreators)(CommunicatorWorking))
